import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=4c4c5c02&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4c5c02')) {
      api.createRecord('4c4c5c02', component.options)
    } else {
      api.reload('4c4c5c02', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=4c4c5c02&", function () {
      api.rerender('4c4c5c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2529HyhDyRHGb/JS/comp/ImgFallback2.vue"
export default component.exports